module.exports = __webpack_public_path__ + "img/menu6.93c6730b.png";